import { WineModel as AdminWineModel } from "@vini-wine/admin-core-models";
import { WineModel as AnalyticWineModel } from "@vini-wine/analytic-core-models";
import { WineModel as OfferWineModel } from "@vini-wine/offer-core-models";
import { WineModel as ContentWineModel } from "@vini-wine/content-core-models";

type WineModels =
  | AdminWineModel
  | AnalyticWineModel
  | OfferWineModel
  | ContentWineModel;
export const getWineNameConvention = (wine: WineModels): string => {
  const wineRegion = wine.region;
  let wineRegionCountry = undefined;
  // if the country is present in the wine region
  if (wineRegion && "country" in wineRegion) {
    wineRegionCountry = wineRegion.country;
  }

  const wineryName = wine?.winery?.name;
  const wineName = wine.name;
  const wineTypeName = wine?.wineType?.name;
  const regionName = wineRegion?.name;

  const countryName = wineRegionCountry ? `, ${wineRegionCountry.name}` : "";

  return `${wineryName} ${wineName} ${wineTypeName}, ${regionName}${countryName}`;
};
